export default class ValidateSearchTerm {
  public static readonly SPECIAL_CHARS = '%$#@+=&|><!(){}[]^"~*?:\\/';
  /* eslint-disable-next-line */
  public static readonly SPECIAL_CHARS_REGEX = /[%$#@+=&|><!(){}\[\]^"~*?:\\/]/g;

  public static validate(searchTerm: string): string {
    return searchTerm.replace(ValidateSearchTerm.SPECIAL_CHARS_REGEX, '')
      .replace(/\s\s+/g, ' ')
      .trim();
  }
}
